/* eslint-disable */
import { createWebHistory, createRouter } from "vue-router";
import { useMainStore } from "../store/main";
import ErrorComponent from "@/components/Error";
import DataLayerService from "@/services/data-layer.service";

// Helper to get Pinia store dynamically (for use in callbacks/guards)
const getPiniaStore = () => useMainStore();

// Static routes lookup (same data as in Pinia store, but available at module load time)
const staticRoutes = [
  { Name: "/", Value: "home" },
  { Name: "/essence", Value: "essence" },
  { Name: "/deals", Value: "modifydeal" },
  { Name: "/site/list", Value: "sitelist" },
  { Name: "/site/create", Value: "sitecreate" },
  { Name: "/site/edit/:id", Value: "siteedit" },
  { Name: "/sites", Value: "newsitelist" },
  { Name: "/acceleratorsite", Value: "acceleratorsite" },
  { Name: "/acceleratorsite/:id", Value: "acceleratoredit" },
  { Name: "/leadads", Value: "leadadslist" },
  { Name: "/elevatelist", Value: "elevatelist" },
  { Name: "/elevatelist/:id", Value: "elevateedit" },
  { Name: "/newsite/create", Value: "newsitecreate" },
  { Name: "/newsite/edit/:id", Value: "newsiteedit" },
  { Name: "/newsite/copy/:id", Value: "newsitecopy" },
  { Name: "/site/copy/:id", Value: "sitecopy" },
  { Name: "/performance", Value: "performance" },
  { Name: "/myambassadors", Value: "myambassadors" },
  { Name: "/myfriends", Value: "myfriends" },
  { Name: "/relations", Value: "relations" },
  { Name: "/user/list", Value: "userlist" },
  { Name: "/user/create", Value: "usercreate" },
  { Name: "/user/edit/:id", Value: "useredit" },
  { Name: "/companies", Value: "companylist" },
  { Name: "/company/create", Value: "companycreate" },
  { Name: "/company/edit/:id", Value: "companyedit" },
  { Name: "/changelog/:id", Value: "changelog" },
  { Name: "/contact/list", Value: "contactlist" },
  { Name: "/errorsummary", Value: "errorsummary" },
  { Name: "/calllog", Value: "calllogsite" },
  { Name: "/calllog/:id", Value: "calllogdashboard" },
  { Name: "/calllog/:id/:keyid", Value: "calllogview" },
  { Name: "/sessiondashboard", Value: "sessionssite" },
  { Name: "/sessiondashboard/:id", Value: "sessionsdashboard" },
  { Name: "/sessiondashboard/:id/:keyid", Value: "sessionsview" },
  { Name: "/sessionlogdashboard/:id", Value: "sessionlogdashboard" },
  { Name: "/sessionlogdashboard/:id/:keyid", Value: "sessionlogview" },
  { Name: "/errorlogbycompany", Value: "companyerrordashboard" },
  { Name: "/errorlogbycompany/:id", Value: "companyerrorview" },
  { Name: "/ongoingerror", Value: "ongoingerrordashboard" },
  { Name: "/ongoingerrorbyerrorlogid/:id", Value: "ongoingerrorview" },
  { Name: "/allongoingerror", Value: "allongoingerrordashboard" },
  { Name: "/allongoingerrorbyerrorlogid/:id", Value: "allongoingerrorview" },
  { Name: "/activeorders", Value: "activeorders" },
  { Name: "/sitechangelog/:id", Value: "siteChangelog" },
  { Name: "/companychangelog/:id", Value: "companyChangelog" },
  { Name: "/editdeal/:id", Value: "editdealnew" },
  { Name: "/newonsitemessage", Value: "newonsitemessage" },
  { Name: "/deals/deallist", Value: "managedeallistnew" },
  { Name: "/copydealnew/:id", Value: "copydeal" },
  { Name: "/copydeal/:id", Value: "copydealnew" },
  { Name: "/searchdeal/:id", Value: "dealsearch" },
  { Name: "/deals/create", Value: "managedealupdateCreate" },
  { Name: "/deals/edit/:id", Value: "managedealupdateById" },
  { Name: "/updatetranslation", Value: "updatetranslation" },
  { Name: "/notfound", Value: "notfound" },
  { Name: "/signupwizard", Value: "signupwizard" },
  { Name: "/overview", Value: "overview" },
  { Name: "/contentgenerator", Value: "contentgenerator" },
  { Name: "/aicontent", Value: "aicontent" },
  { Name: "/aivideocontent", Value: "aivideocontent" },
  { Name: "/ratingreview", Value: "ratingreviewlist" },
  { Name: "/ratingreview/:id", Value: "ratingreviewedit" },
  { Name: "/reviewsdashboard", Value: "reviewsdashboard" },
  { Name: "/summariesdashboard", Value: "summariesdashboard" },
  { Name: "/reviewsdashboard/:siteId/:reviewId/:itemId/:contactId", Value: "reviewsedit" },
  { Name: "/summariesdashboard/:siteId/:itemId", Value: "summariesedit" },
  { Name: "/commentsdashboard", Value: "commentsdashboard" },
  { Name: "/commentsdashboard/:siteId/:contactId/:reviewId", Value: "commentsedit" },
  { Name: "/votesdashboard", Value: "votesdashboard" },
  { Name: "/votesdashboard/:siteId/:reviewId/:voterId", Value: "votesedit" },
  { Name: "/leadads/:id", Value: "leadads" },
  { Name: "/acceleratordashboard/products", Value: "productsite" },
  { Name: "/acceleratordashboard/products/:id", Value: "productdashboard" },
  { Name: "/acceleratordashboard/products/:id/:keyid", Value: "productview" },
  { Name: "/acceleratordashboard/products/version/:id/:keyid", Value: "productversion" },
  { Name: "/acceleratordashboard/page", Value: "pagesite" },
  { Name: "/acceleratordashboard/page/:id", Value: "pagedashboard" },
  { Name: "/acceleratordashboard/page/:id/:keyid", Value: "pageview" },
  { Name: "/acceleratordashboard/page/version/:id/:keyid", Value: "pageversion" },
  { Name: "/acceleratordashboard/orders", Value: "ordersite" },
  { Name: "/acceleratordashboard/orders/:id", Value: "orderdashboard" },
  { Name: "/acceleratordashboard/orders/:id/:keyid", Value: "orderview" },
  { Name: "/acceleratordashboard/orders/:id/:keyid/:type", Value: "orderversion" },
  { Name: "/acceleratordashboard/contacts", Value: "contactsite" },
  { Name: "/acceleratordashboard/contacts/:id", Value: "contactdashboard" },
  { Name: "/acceleratordashboard/contacts/:id/:keyid", Value: "contactview" },
  { Name: "/acceleratordashboard/inventories", Value: "inventorysite" },
  { Name: "/acceleratordashboard/inventories/:id", Value: "inventorydashboard" },
  { Name: "/acceleratordashboard/inventories/:keyid/:siteId", Value: "inventoryview" },
  { Name: "/acceleratordashboard/markets", Value: "marketsite" },
  { Name: "/acceleratordashboard/markets/:id", Value: "marketdashboard" },
  { Name: "/acceleratordashboard/markets/:id/:keyid", Value: "marketview" },
  { Name: "/acceleratordashboard/receipt", Value: "receiptsite" },
  { Name: "/acceleratordashboard/receipt/:id", Value: "receiptdashboard" },
  { Name: "/acceleratordashboard/receipt/:id/:keyid", Value: "receiptview" },
  { Name: "/onsitedashboard", Value: "onsitedashboard" },
  { Name: "/blank", Value: "blank" },
];

// Static GetRoutePath function (works at module load time without store)
const GetRoutePath = (pathName) => {
  const routeObj = staticRoutes.filter((path) => path.Value === pathName);
  if (routeObj.length > 0) {
    return routeObj[0].Name;
  }
  return null;
};

var Page = [
  "DealCreate",
  "SiteCreate",
  "Performance",
  "VisitRatio",
  "MyAmbassadors",
  "MyFriends",
];
async function requireAuth(to, from, next) {
  // Most auth and route validation is now handled by the global beforeEach guard
  // This function now only handles company-specific user info loading logic
  const store = getPiniaStore();
  const _userInfo = store.cognitoInfo;
  if (
    _userInfo &&
    (_userInfo.companyid == null ||
      _userInfo.companyid == undefined ||
      _userInfo.companyid == "")
  ) {
    await DataLayerService.get("/user/getuserinfo").then(async (userRes) => {
      if (userRes) {
        if (
          userRes.companyId == "" ||
          userRes.companyId == null ||
          userRes.companyId == undefined
        ) {
          this.$router.push({ name: "Logout" });
          return;
        }
        var mainres = {};
        mainres.email = _userInfo.email;
        mainres.username = _userInfo.username;
        mainres.displayname = userRes.displayName;
        mainres.companyid = userRes.companyId;
        mainres.companyname = userRes.companyName;
        mainres.companylist = userRes.companyIdList;
        mainres.role = userRes.role;
        mainres.token = store.cognitoInfo.token;
        store.setCognitoInfo(mainres);
        return mainres;
      } else {
        next({ name: "Logout" });
        return;
      }
    });
  }

  if (
    [
      "DealCreate",
      "SiteCreate",
      "Performance",
      "VisitRatio",
      "MyAmbassadors",
      "MyFriends",
    ].includes(to.name) &&
    _userInfo.companyid === "_all" &&
    from.name === null
  ) {
    next({ name: "Home" });
    return;
  }

  next();
}

const routes = [
  {
    path: GetRoutePath("home"),
    name: "Home",
    //component: () => import("../views/Home.vue"),
    // component: () => import("../views/Dashboard/Dashboard.vue"),
    component: () => import("../views/VoyadoDashboard/voyadodashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("newsitelist"),
    name: "NewSiteList",
    component: () => import("../views/NewSite/Site.vue"),
  },
  {
    path: GetRoutePath("elevatelist"),
    name: "elevatelist",
    component: () => import("../views/AcceleratorConfiguration/Elevate/ElevateSites.vue"),
  },
  {
    path: GetRoutePath("elevateedit"),
    name: "elevateedit",
    component: () => import("../views/AcceleratorConfiguration/Elevate/ElevateConfig.vue"),
  },
  {
    path: GetRoutePath("acceleratorsite"),
    name: "acceleratorsite",
    component: () => import("../views/AcceleratorConfiguration/ECommerce/ECommerceSite.vue"),
  },
  {
    path: GetRoutePath("acceleratoredit"),
    name: "acceleratoredit",
    component: () => import("../views/AcceleratorConfiguration/ECommerce/ECommerceConfig.vue"),
  },
  {
    path: GetRoutePath("leadadslist"),
    name: "leadadslist",
    component: () => import("../views/AcceleratorConfiguration/LeadAds/LeadadsSite.vue"),
  },
  {
    path: GetRoutePath("leadads"),
    name: "leadadsedit",
    component: () => import("../views/AcceleratorConfiguration/LeadAds/LeadadsConfig.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("newsitecreate"),
    name: "NewSiteCreate",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("newsiteedit"),
    name: "NewSiteEdit",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("newsitecopy"),
    name: "NewSiteCopy",
    component: () => import("../views/NewSite/SiteCreate.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("sitelist"),
    name: "SiteList",
    component: () => import("../views/Site/Site.vue"),
  },
  {
    path: GetRoutePath("sitecreate"),
    name: "SiteCreate",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("siteedit"),
    name: "SiteEdit",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: GetRoutePath("sitecopy"),
    name: "SiteCopy",
    component: () => import("../views/Site/Create.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("siteChangelog"),
    name: "SiteChangelog",
    component: () => import("../views/Reports/SiteChangelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companyChangelog"),
    name: "CompanyChangelog",
    component: () => import("../views/Reports/CompanyChangelog.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: GetRoutePath("dealcreate"),
  //   name: "DealCreate",
  //   component: () => import("../views/Deal/Create.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: GetRoutePath("performance"),
    name: "Performance",
    component: () => import("../views/Reports/Performance/Performance.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("myambassadors"),
    name: "Ambassadors",
    component: () => import("../views/Reports/MyAmbassadors/MyAmbassadorsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("myfriends"),
    name: "Friends",
    component: () => import("../views/Reports/MyFriends/MyFriendsDashboard.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: GetRoutePath("relations"),
    name: "Relations",
    component: () => import("../views/Reports/Relations/RelationsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companylist"),
    name: "CompanyList",
    component: () => import("../views/Company/CompanyList.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companycreate"),
    name: "CompanyCreate",
    component: () => import("../views/Company/CompanyIndex.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companyedit"),
    name: "CompanyEdit",
    component: () => import("../views/Company/CompanyIndex.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("changelog"),
    name: "Changelog",
    component: () => import("../views/Reports/Changelog.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("userlist"),
    name: "UserList",
    component: () => import("../views/User/User.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("usercreate"),
    name: "UserCreate",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("useredit"),
    name: "UserEdit",
    component: () => import("../views/User/CreateUser.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("ratingreviewlist"),
    name: "ratingreviewlist",
    component: () => import("../views/RatingsAndReviews/RatingsAndReviews.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("ratingreviewedit"),
    name: "ratingreviewedit",
    component: () => import("../views/RatingsAndReviews/RatingsAndReviewsEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("reviewsdashboard"),
    name: "reviewsdashboard",
    component: () => import("../views/RatingsAndReviews/Dashboards/ReviewsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("reviewsedit"),
    name: "reviewsedit",
    component: () => import("../views/RatingsAndReviews/Dashboards/ReviewsEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("summariesdashboard"),
    name: "summariesdashboard",
    component: () => import("../views/RatingsAndReviews/Dashboards/SummariesDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("summariesedit"),
    name: "summariesedit",
    component: () => import("../views/RatingsAndReviews/Dashboards/SummariesEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("commentsdashboard"),
    name: "commentsdashboard",
    component: () => import("../views/RatingsAndReviews/Dashboards/CommentsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("commentsedit"),
    name: "commentsedit",
    component: () => import("../views/RatingsAndReviews/Dashboards/CommentsEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("votesdashboard"),
    name: "votesdashboard",
    component: () => import("../views/RatingsAndReviews/Dashboards/VotesDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("votesedit"),
    name: "votesedit",
    component: () => import("../views/RatingsAndReviews/Dashboards/VotesEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("updatetranslation"),
    name: "Translation",
    component: () => import("../views/Translation/Translation.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("contactlist"),
    name: "FailedContact",
    component: () => import("../views/OperationDashboard/FailedContact/FailedContact.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("errorsummary"),
    name: "Error",
    component: () => import("../views/OperationDashboard/OnsiteErrors/ErrorSummary.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("calllogsite"),
    name: "calllog",
    component: () => import("../views/OperationDashboard/CallLogs/CallLogDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("calllogview"),
    name: "calllogbykeyid",
    component: () => import("../views/OperationDashboard/CallLogs/CallLogView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("sessionssite"),
    name: "sessiondashboard",
    component: () => import("../views/OperationDashboard/Sessions/SessionsSite.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("sessionsdashboard"),
    name: "sessiondashboardbyid",
    component: () => import("../views/OperationDashboard/Sessions/SessionsDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("sessionsview"),
    name: "sessiondashboardbykeyid",
    component: () => import("../views/OperationDashboard/Sessions/SessionsView.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: GetRoutePath("sessionlogsite"),
  //   name: "sessionlogdashboard",
  //   component: () => import("../views/OperationDashboard/SessionLogs/SessionLogSite.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: GetRoutePath("sessionlogdashboard"),
    name: "sessionlogdashboardbyid",
    component: () => import("../views/OperationDashboard/SessionLogs/SessionLogDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("sessionlogview"),
    name: "sessionlogdashboardbykeyid",
    component: () => import("../views/OperationDashboard/SessionLogs/SessionLogView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companyerrordashboard"),
    name: "errorlogbycompany",
    component: () => import("../views/OperationDashboard/ErrorLogs/CompanyErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("companyerrorview"),
    name: "errorlogbycompanyid",
    component: () => import("../views/OperationDashboard/ErrorLogs/CompanyErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("ongoingerrordashboard"),
    name: "ongoingerror",
    component: () => import("../views/OperationDashboard/OngoingErrors/CompanyOngoingErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("ongoingerrorview"),
    name: "ongoingerrorbyerrorlogid",
    component: () => import("../views/OperationDashboard/OngoingErrors/CompanyOngoingErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("allongoingerrordashboard"),
    name: "allongoingerror",
    component: () => import("../views/OperationDashboard/AllOngoingErrors/CompanyAllOngoingErrorDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("allongoingerrorview"),
    name: "allongoingerrorbyerrorlogid",
    component: () => import("../views/OperationDashboard/AllOngoingErrors/CompanyAllOngoingErrorView.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("activeorders"),
    name: "activeorders",
    component: () => import("../views/OperationDashboard/ActiveOrders/ActiveOrdersDashboard.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("modifydeal"),
    name: "ModifyDeal",
    component: () => import("../views/DealList/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("managedeallistnew"),
    name: "ManageDealListNew",
    component: () => import("../views/ManageDealsNew/List.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("newonsitemessage"),
    name: "NewOnsiteMessage",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("copydeal"),
    name: "copydeal",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("copydealnew"),
    name: "copydealnew",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("dealsearch"),
    name: "DealSearch",
    component: () => import("../views/Reports/DealSearch.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("notfound"),
    name: "notfound",
    component: () => import("../views/Pages/Notfound.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("signupwizard"),
    name: "Signupwizard",
    component: () => import("../views/signupwizard/signupwizard.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: GetRoutePath("managedealupdate"),
  //   name: "ManageDealUpdate",
  //   component: () => import("../views/ManageDealUpdate/index.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: () => import("../views/forgotpassword.vue"),
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    component: () => import("../views/resetpassword.vue"),
  },
  {
    path: "/changepassword",
    name: "ChangePassword",
    component: () => import("../views/changepassword.vue"),
  },

  {
    path: GetRoutePath("managedealupdateCreate"),
    name: "ManageDealUpdateCreate",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: GetRoutePath("editdealnew"),
    name: "EditDealNew",
    component: () => import("../views/UpdateDealNew/Update.vue"),
    beforeEnter: requireAuth,
  },

  {
    path: GetRoutePath("managedealupdateById"),
    name: "ManageDealUpdateById",
    component: () => import("../views/ManageDealUpdate/index.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("contentgenerator"),
    name: "contentgenerator",
    component: () => import("../views/ContentGenerator/contentgenerator.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("aicontent"),
    name: "aicontent",
    component: () => import("../views/AiContent/aicontent.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("aivideocontent"),
    name: "aivideocontent",
    component: () => import("../views/AiContent/aiVideoContent.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: GetRoutePath("essence"),
    name: "essence",
    component: () => import("../views/Essence/index.vue"),
  },
  // {
  //   path: "/login",
  //   name: "Login",
  //   beforeEnter() {
  //     // console.log(auth.auth.getSession(), 'auth.auth.getSession()')
  //     auth.auth.getSession();
  //   },
  // },
  // {
  //   path: "/login/oauth2/code/cognito",
  //   name: "LoginCognito",
  //   beforeEnter() {
  //     var currUrl = window.location.href;
  //     auth.auth.parseCognitoWebResponse(currUrl);
  //   },
  // },
  {
    path: "/error",
    component: ErrorComponent,
    beforeEnter: requireAuth,
  },
  {
    path: "/logout",
    name: "Logout",
    beforeEnter(to, from, next) {
      const store = getPiniaStore();
      store.loader = 0;
      store.resetCallLogLogout();
      store.resetErrorLogsSite();
      store.resetErrorIntegrationsValue();
      store.resetErrorModuleValue();
      
      store.resetCognitoInfo();
      store.resetMenudataInfo();
      store.resetRoutedataInfo();
      store.resetDealFilter();
      store.resetDashboardInfo();
      store.resetDashbboardFilter();
      store.resetLead();
      store.resetFacebookPopup();
      store.resetIntegrationsValue();
      store.resetModuleValue();
      store.resetAcceleratorProducts();
      store.resetAcceleratorPages();
      store.resetAcceleratorOrders();
      store.resetOrderIntegrationsValue();
      store.resetNotifiedErrorCount();
      store.resetAcceleratorMarket();
      store.resetAcceleratorContact();
      store.resetContactIntegrationsValue();
      store.resetAcceleratorInventory();
      store.resetInventoryIntegrationsValue();
      store.resetAcceleratorReceipt();
      store.resetReceiptIntegrationsValue();
      store.resetOnLogout();

      const queryParams = from.query;
      console.log(queryParams, "queryparams after logout route called");
      
      next({ path: "/login", query: queryParams });
    },
  },
  // {
  //   path: "/logout",
  //   name: "Logout",
  //   beforeEnter(to, from, next) {
  //     // console.log(auth,876);
  //     auth.logout();
  //     next("/");
  //   },
  // },
  {
    path: GetRoutePath("blank"),
    name: "Blank",
    component: () => import("../views/Blank.vue"),
  },
  {
    path: GetRoutePath("onsitedashboard"),
    name: "OnsiteDashboard",
    component: () => import("../views/Dashboard/Dashboard.vue"),
  },

  {
    path: GetRoutePath("overview"),
    name: "VoyadoDashboard",
    component: () => import("../views/VoyadoDashboard/voyadodashboard.vue"),
    beforeEnter: requireAuth,
  },
  // {
  //   path: GetRoutePath("acceleratordashboard"),
  //   name: "acceleratordashboard",
  //   component: () => import("../views/AcceleratorDashboard/Accelerator.vue"),
  // },
  {
    path: GetRoutePath("productsite"),
    name: "acceleratordashboardproducts",
    component: () => import("../views/AcceleratorDashboard/Products/ProductSites.vue"),
  },
  {
    path: GetRoutePath("productdashboard"),
    name: "acceleratordashboardproductsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Products/ProductDashboard.vue"),
  },
  {
    path: GetRoutePath("productview"),
    name: "acceleratordashboardproductbykeyid",
    component: () => import("../views/AcceleratorDashboard/Products/ProductView.vue"),
  },
  {
    path: GetRoutePath("productversion"),
    name: "acceleratordashboardproductversion",
    component: () => import("../views/AcceleratorDashboard/Products/ProductVersion.vue"),
  },
  {
    path: GetRoutePath("pagesite"),
    name: "acceleratordashboardpage",
    component: () => import("../views/AcceleratorDashboard/Pages/PageSites.vue"),
  },
  {
    path: GetRoutePath("pagedashboard"),
    name: "acceleratordashboardpagebyid",
    component: () =>
      import("../views/AcceleratorDashboard/Pages/PageDashboard.vue"),
  },
  {
    path: GetRoutePath("pageview"),
    name: "acceleratordashboardpagebykeyid",
    component: () => import("../views/AcceleratorDashboard/Pages/PageView.vue"),
  },
  {
    path: GetRoutePath("pageversion"),
    name: "acceleratordashboardpageversion",
    component: () => import("../views/AcceleratorDashboard/Pages/PageVersion.vue"),
  },
  {
    path: GetRoutePath("ordersite"),
    name: "acceleratordashboardorders",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderSites.vue"),
  },
  {
    path: GetRoutePath("orderdashboard"),
    name: "acceleratordashboardordersbyid",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderDashboard.vue"),
  },
  {
    path: GetRoutePath("orderview"),
    name: "acceleratordashboardorderbykeyid",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderView.vue"),
  },
  {
    path: GetRoutePath("orderversion"),
    name: "acceleratordashboardorderversion",
    component: () => import("../views/AcceleratorDashboard/Orders/OrderVersion.vue"),
  },
  {
    path: GetRoutePath("contactsite"),
    name: "acceleratordashboardcontacts",
    component: () => import("../views/AcceleratorDashboard/Contacts/ContactSites.vue"),
  },
  {
    path: GetRoutePath("contactdashboard"),
    name: "acceleratordashboardcontactsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Contacts/ContactDashboard.vue"),
  },
  {
    path: GetRoutePath("contactview"),
    name: "acceleratordashboardcontactsbykeyid",
    component: () => import("../views/AcceleratorDashboard/Contacts/ContactView.vue"),
  },
  {
    path: GetRoutePath("inventorysite"),
    name: "acceleratordashboardinventories",
    component: () => import("../views/AcceleratorDashboard/Inventories/InventorySites.vue"),
  },
  {
    path: GetRoutePath("inventorydashboard"),
    name: "acceleratordashboardinventoriesbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Inventories/InventoryDashboard.vue"),
  },
  {
    path: GetRoutePath("inventoryview"),
    name: "acceleratordashboardinventoriesbykeyid",
    component: () => import("../views/AcceleratorDashboard/Inventories/InventoryView.vue"),
  },
  {
    path: GetRoutePath("marketsite"),
    name: "acceleratordashboardmarkets",
    component: () => import("../views/AcceleratorDashboard/Markets/MarketSites.vue"),
  },
  {
    path: GetRoutePath("marketdashboard"),
    name: "acceleratordashboardmarketsbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Markets/MarketDashboard.vue"),
  },
  {
    path: GetRoutePath("marketview"),
    name: "acceleratordashboardmarketsbyidkeyid",
    component: () => import("../views/AcceleratorDashboard/Markets/MarketView.vue"),
  },
  {
    path: GetRoutePath("receiptsite"),
    name: "acceleratordashboardreceipt",
    component: () => import("../views/AcceleratorDashboard/Receipts/ReceiptSites.vue"),
  },
  {
    path: GetRoutePath("receiptdashboard"),
    name: "acceleratordashboardreceiptbyid",
    component: () =>
      import("../views/AcceleratorDashboard/Receipts/ReceiptDashboard.vue"),
  },
  {
    path: GetRoutePath("receiptview"),
    name: "acceleratordashboardreceiptbyidkeyid",
    component: () => import("../views/AcceleratorDashboard/Receipts/ReceiptView.vue"),
  },
];

// Add a catch-all route for unmatched paths
routes.push({
  path: "/:pathMatch(.*)*",
  name: "CatchAll",
  component: () => import("../views/Pages/Notfound.vue"),
});

const router = createRouter({
  history: createWebHistory(),
  // base:"/",
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = getPiniaStore();
  store.setActiveRoute(to.meta.module);
  
  // Skip validation for authentication and error routes
  const skipValidationRoutes = [
    "Login", 
    "Logout", 
    "ForgotPassword", 
    "ResetPassword", 
    "ChangePassword", 
    "notfound", 
    "CatchAll"
  ];
  
  if (skipValidationRoutes.includes(to.name)) {
    next();
    return;
  }
  
  // Check if user is authenticated
  if (
    !store.cognitoInfo ||
    Object.keys(store.cognitoInfo).length === 0
  ) {
    let decodedPath = decodeURIComponent(to.fullPath);
    console.log(decodedPath, "redirecting to login page");

    const url = new URL(window.location.origin + to.fullPath);
    const queryParams = new URLSearchParams(url.search);
    const queryString = queryParams.toString();

    let redirectPath = to.path;
    if (queryString) {
      redirectPath += `&${queryString}`;
    }

    next({
      path: "/login",
      query: {
        redirect: redirectPath,
      },
    });
    return;
  }
  
  // Ensure menu data is loaded
  if (
    !store.menudataInfo ||
    Object.keys(store.menudataInfo).length === 0
  ) {
    try {
      const result = await DataLayerService.get("/home/GetMenuData");
      if (result && Object.keys(result).length > 0) {
        store.setMenudataInfo(result);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load menu data:", error);
      next({ name: "notfound" });
      return;
    }
  }

  // Ensure user info is loaded
  const _userInfo = store.cognitoInfo;
  if (
    _userInfo &&
    (_userInfo.companyid == null ||
      _userInfo.companyid == undefined ||
      _userInfo.companyid == "")
  ) {
    try {
      const userRes = await DataLayerService.get("/user/getuserinfo");
      if (userRes) {
        if (
          userRes.companyId == "" ||
          userRes.companyId == null ||
          userRes.companyId == undefined
        ) {
          next({ name: "Logout" });
          return;
        }
        var mainres = {};
        mainres.email = _userInfo.email;
        mainres.username = _userInfo.username;
        mainres.displayname = userRes.displayName;
        mainres.companyid = userRes.companyId;
        mainres.companyname = userRes.companyName;
        mainres.companylist = userRes.companyIdList;
        mainres.role = userRes.role;
        mainres.token = store.cognitoInfo.token;
        store.setCognitoInfo(mainres);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load user info:", error);
      next({ name: "Logout" });
      return;
    }
  }

  // Ensure route data is loaded
  if (
    !store.routedataInfo ||
    Object.keys(store.routedataInfo).length === 0
  ) {
    try {
      const result = await DataLayerService.get("/home/GetActiveRole");
      if (result && result.length > 0) {
        store.setRoutedataInfo(result);
      } else {
        next({ name: "Logout" });
        return;
      }
    } catch (error) {
      console.error("Failed to load route data:", error);
      next({ name: "notfound" });
      return;
    }
  }
  
  // Block Ratings & Reviews routes when the feature is disabled
  const ratingsAndReviewsRoutes = [
    "ratingreviewlist",
    "ratingreviewedit",
    "reviewsdashboard",
    "reviewsedit",
    "summariesdashboard",
    "summariesedit",
    "commentsdashboard",
    "commentsedit",
    "votesdashboard",
    "votesedit",
  ];
  if (ratingsAndReviewsRoutes.includes(to.name) && !store.isRatingsAndReviewsEnabled) {
    next({ name: "notfound" });
    return;
  }

  // Validate the route exists in the user's allowed routes
  let checkRoute;
  if (to.name) {
    
    // Routes that don't require role validation (new dashboard routes)
    // const skipRoleValidationRoutes = [
    //   "CommentsEdit",
    //   "VotesEdit",
    // ];
    
    // if (skipRoleValidationRoutes.includes(to.name)) {
    //   next();
    //   return;
    // }
    
    // Check if the route exists in the user's allowed routes
    checkRoute = store.routedataInfo?.find(
      (x) => x.name.toLowerCase() === to.name.toLowerCase()
    );
    
    // If route not found, also check if it's a valid route in the router but not in allowed routes
    if (!checkRoute) {
      next({ name: "notfound" });
      return;
    }
    
  } else {
    // If no route name is found, it means the route doesn't exist in the router
    next({ name: "notfound" });
    return;
  }
  
  next();
});

export default router;
